// extracted by mini-css-extract-plugin
export var h1 = "button-module--h-1--cFHZs";
export var h2 = "button-module--h-2--Y238d";
export var h3 = "button-module--h-3--u4XMb";
export var genHeader = "button-module--gen-header--1r0Rc";
export var p1 = "button-module--p-1--xPxAz";
export var p2 = "button-module--p-2--2tl_I";
export var p3 = "button-module--p-3--bPOqn";
export var button = "button-module--button--sIbF9";
export var hoverContent = "button-module--hover-content--1X88-";
export var clickContent = "button-module--click-content--3UKRQ";
export var mainContent = "button-module--main-content--bJ_Jg";
export var clicked = "button-module--clicked--2sm_g";